import 'angular-chart.js';

import { NgModule } from 'ng-metadata/core';
import { CurrencyComponent } from 'common/currency/currency.component';

@NgModule({
  imports: [
    // http://jtblin.github.io/angular-chart.js/
    'chart.js',
  ],
  declarations: [
    CurrencyComponent,
  ],
})
export class CurrencyModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/common/currency/currency.module.ts